import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { CheckboxGroupInputWUT } from "../../inputs/checkbox-group-input/checkbox-group-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { NUMBER_OF_COLUMNS } from "../options-layout/options-layout-constants.js";
import { Widget } from "../widget/widget.js";
const CheckboxGroupFieldWUT = ({
  id,
  target,
  label,
  hideLabel = false,
  options,
  addOther,
  addOtherLabel,
  addOtherPlaceholder,
  required = false,
  value = null,
  onChange,
  onFocus,
  onBlur,
  error,
  hasError = false,
  errorMessage,
  disabled = false,
  description,
  otherInputCharacterLimit,
  FieldLayout,
  numberOfColumns = NUMBER_OF_COLUMNS.ONE,
  hideBox = false,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        CheckboxGroupInputWUT,
        {
          label,
          options,
          addOther,
          addOtherLabel,
          addOtherPlaceholder,
          required,
          value,
          onFocus,
          onBlur,
          disabled,
          otherInputCharacterLimit,
          numberOfColumns,
          hideBox,
          onChange,
          hasError,
          inputId,
          labelId,
          ariaDescribedBy,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  CheckboxGroupFieldWUT
};
//# sourceMappingURL=checkbox-group-field-wut.js.map
